import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=6e42654b&scoped=true&"
import script from "./StatsTable.vue?vue&type=script&lang=js&"
export * from "./StatsTable.vue?vue&type=script&lang=js&"
import style1 from "./StatsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42654b",
  null
  
)

export default component.exports